import React, { createContext, useState, useContext } from 'react';

const GameContext = createContext();

export const useGame = () => {
    return useContext(GameContext);
};

export const GameProvider = ({ children }) => {
    const [gameState, setGameState] = useState('ready');
    const [gameId, setGameId] = useState(0);

    // New State for Challenges
    // gameMode: 'standard' | 'create_challenge' | 'attempt_challenge'
    const [gameMode, setGameMode] = useState('standard');
    
    // Data needed for the challenge (wager, target score, opponent info)
    const [challengeData, setChallengeData] = useState(null);

    const value = {
        gameState,
        setGameState,
        gameId,
        setGameId,
        gameMode,
        setGameMode,
        challengeData,
        setChallengeData
    };

    return (
        <GameContext.Provider value={value}>
            {children}
        </GameContext.Provider>
    );
};